import { ProviderCheck, ProviderCheckRun } from '../../../models/profit/profit.model';
import { useGet, useSend } from '../../useApi';

// GET /admin/profit/provider-checks: Meta's and Anthropic's daily cost vs ours.
// POST /admin/profit/provider-checks/run: check one full day now.
const useProviderChecks = () => {
  const { data, loading, fetch } = useGet<ProviderCheck[]>('Failed to load provider checks');
  const { loading: running, send } = useSend<ProviderCheckRun>('Could not check that day');
  const fetchChecks = () => fetch('api/v1/admin/profit/provider-checks');
  return {
    checks: data ?? [],
    loading,
    running,
    fetchChecks,
    checkDay: (day: string, onDone?: (run: ProviderCheckRun) => void) =>
      send({ url: 'api/v1/admin/profit/provider-checks/run', method: 'post', params: { day } }, (run) => {
        fetchChecks();
        onDone?.(run);
      }),
  };
};

export default useProviderChecks;
